import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonService } from 'src/app/shared/services/common.service';
import { navItems } from '../sidebar/sidebar-data';
import { FormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'src/app/core/services/localStorage/local-storage.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { LogoutDialogComponent } from '../../../components/logout-dialog/logout-dialog.component';

const MOBILE_VIEW = '(max-width: 768px)';

@Component({
  selector: 'app-sidebar-2',
  standalone: true,
  imports: [MaterialModule, CommonModule, RouterLink, RouterLinkActive, FormsModule, TablerIconsModule],
  templateUrl: './sidebar-2.component.html',
  styleUrl: './sidebar-2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Sidebar2Component implements OnInit, OnDestroy {
  @Output() sideBarToggled = new EventEmitter<boolean>();
  @Output() mobileToggled = new EventEmitter<boolean>();

  isSideBarToggled: boolean = false; // Desktop mini mode
  isMobileOpen: boolean = false;     // Mobile drawer open state
  isMobileScreen: boolean = false;
  navItems: any[] = navItems;

  private breakpointSub: Subscription = Subscription.EMPTY;

  constructor(
    private cdRef: ChangeDetectorRef,
    private commonService: CommonService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private toastService: ToastService
  ) { }

  openLogoutModal(): void {
    const dialogRef = this.dialog.open(LogoutDialogComponent, {
      width: '100%',
      maxWidth: '440px',
      panelClass: 'custom-modal-dialog'
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        if (this.isMobileScreen) {
          this.closeMobile();
        }
        this.localStorageService.logout();
        this.toastService.successToast('Logged out successfully');
      }
    });
  }

  ngOnInit(): void {
    this.breakpointSub = this.breakpointObserver.observe([MOBILE_VIEW]).subscribe((result) => {
      this.isMobileScreen = result.matches;
      if (this.isMobileScreen) {
        // Automatically collapse/close sidebar on mobile
        this.isMobileOpen = false;
        this.mobileToggled.emit(false);
      }
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.breakpointSub.unsubscribe();
  }

  /**
   * Toggle Desktop mini sidebar
   */
  sideBarToggle(): void {
    this.isSideBarToggled = !this.isSideBarToggled;
    this.sideBarToggled.emit(this.isSideBarToggled);
    this.commonService.isNavHeaderFullWidth.next(this.isSideBarToggled);
    this.cdRef.detectChanges();
  }

  /**
   * Toggle Mobile drawer
   */
  toggleMobile(): void {
    this.isMobileOpen = !this.isMobileOpen;
    this.mobileToggled.emit(this.isMobileOpen);
    this.cdRef.detectChanges();
  }

  /**
   * Close Mobile drawer
   */
  closeMobile(): void {
    if (this.isMobileOpen) {
      this.isMobileOpen = false;
      this.mobileToggled.emit(false);
      this.cdRef.detectChanges();
    }
  }

  /**
   * Auto-collapse on mobile when navigating
   */
  onLogoClick(): void {
  if (!this.isMobileScreen && this.isSideBarToggled) {
    this.sideBarToggle();
  }
}

onItemClick(): void {
  if (this.isMobileScreen) {
    this.closeMobile();
  } else if (this.isSideBarToggled) {
    this.sideBarToggle();
  }
}
}
